/******************************************
 * small mobile
 *
 * @author          Luke.kim
 * @copyright       Copyright (c) 2013 small.
 * @license         This is dual licensed under the MIT and GPL licenses.
 * @version         0.3
 * @description     수정시에는 modify 태그에 수정부분에 대한 설명을 적을것, 코드 수정 이후에는 수정자가 코드 품질 보장.
 * @since           2013-09-30 10:04
 * @modify
 * @uses            jindo.m.RevealSidebarUI
 * @history 0.2     이벤트 에미터 적용, 뷰 템플릿 적용
 * @history 0.3     메인 추가, nSlideTreshold 옵션 사용
 *
 ******************************************/
//blocker 이슈 대응 준비 background-color:transparent opacity:1
var ssg = ssg || {};
ssg.View = ssg.View || {};

ssg.View.revealMenu = function( htOptions ) {
    $.extend( this, htOptions || {} );
    this.init( );
};

ssg.View.revealMenu.prototype = $.extend( {
    _welHtml: null,
    _welBody: null,
    _welMainBody: null,
    _welLeftArea: null,
    _welRightArea: null,
    _welBlocker: null,
    //_elBlocker: "<div style='position:absolute;top:0px;height:100%;display:none;z-index:3000;-webkit-tap-highlight-color:transparent;background: rgba(0, 0, 0, 0.8)'>",
    _elBlocker: "<div style='position:absolute;top:0px;height:100%;display:none;z-index:3000;-webkit-tap-highlight-color:transparent;background-color:black;opacity:0'>",
    _bOpenLeft: false,
    _bOpenRight: false,
    _oSideLeft: null,
    _oSideRight: null,
    _nScreenHeight: null,
    _htSideLeft: {
        //"elId" : "_left_menu",
        "sClassPrefix": "reveal-left-",
        "nDuration": 300,
        "nMargin": 50,
        "sDirection": "right"
    },
    _htSideRight: {
        //"elId" : "_right_menu",
        "sClassPrefix": "reveal-right-",
        "nDuration": 300,
        "nMargin": 50,
        "sDirection": "left"
    },
    _htEnableScrollCss : {
        'height' : '',
        'overflow' : ''
        //if 'overflow' : 'auto' then it's problem on iphone
    },
    _htDisableScrollCss : {
        'height' : jindo.m.getOsInfo().android && jindo.m.getBrowserInfo().chrome ? '100vh' : '100%',
        'overflow' : 'hidden'
    },
    init: function( ) {
        this._assignElements( );
        this._appendToBlocker();
        this._assignComponents( );
        this._attachEventHandlers( );
        this._attachCustomEvent( );
    },
    _assignElements: function( ) {
        this._welHtml = $('html');
        this._welBody = $('body');
        this._welMainBody = $( '#m_wrap' );
        this._welMainHeader = $( '#header' );
        this._welMainContainer = $( '.mcom_container' );
        this._welBlocker = $(this._elBlocker);
        this._welLeftArea = this._welMainBody.find('.'+this._htSideLeft.sClassPrefix+'nav');
        this._welRightArea = this._welMainBody.find('.'+this._htSideRight.sClassPrefix+'nav');
    },

    _appendToBlocker: function(){
        this._welBlocker.prependTo(this._welMainBody);
    },
    _assignComponents: function( ) {
        if(this._welLeftArea.length > 0){
            this._oSideLeft = new jindo.m.SlideReveal( this._htSideLeft );
        }

        if(this._welRightArea.length > 0){
            this._oSideRight = new jindo.m.SlideReveal( this._htSideRight );
        }
    },
    _attachEventHandlers: function( ) {
        this._welBlocker.on('click', $.proxy( this._onClickBlocker, this ));
        //.$(window).on("orientationchange.revealside",$.proxy(this._resize, this));
        jindo.m.bindRotate($.proxy(this._resize, this));
    },
    _attachCustomEvent: function( ) {
        if(this._oSideLeft !== null){
            this._oSideLeft.attach( 'beforeShow', $.proxy( this._onBeforeShowLeft, this ) );
            this._oSideLeft.attach( 'show', $.proxy( this._onShowLeft, this ) );
            this._oSideLeft.attach( 'beforeHide', $.proxy( this._onBeforeHideLeft, this ) );
            this._oSideLeft.attach( 'hide', $.proxy( this._onHideLeft, this ) );
        }

        if(this._oSideRight !== null){
            this._oSideRight.attach( 'beforeShow', $.proxy( this._onBeforeShowRight, this ) );
            this._oSideRight.attach( 'show', $.proxy( this._onShowRight, this ) );
            this._oSideRight.attach( 'beforeHide', $.proxy( this._onBeforeHideRight, this ) );
            this._oSideRight.attach( 'hide', $.proxy( this._onHideRight, this ) );
        }
    },
    _onClickBlocker: function(){
        if(this._bOpenLeft){
            this.hideBlocker();
            this.hideLeftMenu();
        }

        if(this._bOpenRight){
            this.hideBlocker();
            this.hideRightMenu();
        }
    },
    _onBeforeShowLeft: function( we ) {
        // 안드로이드 2.3에서 높이값 버그 조치
        /*if (this._checkReSize()) {

        }*/
        this._welMainBody.css('height', '');
        this._welHtml.css(this._htDisableScrollCss);
        this._welHtml.css('position', 'fixed');
        this._welBody.css(this._htDisableScrollCss);
        this.emit( we.sType, true );
    },
    _onShowLeft: function( we ) {
        var oSelf = this;
        this._bOpenLeft = true;
        this._resizeBlocker(true);
        this.showBlocker(function(){
            //oSelf._welBlocker.stop().shinsegae({'opacity' : 0.8}, 200, 'easeInCubic');
            oSelf._freezePreventTouch();
        });
        this.emit( we.sType, true);
    },
    _onBeforeHideLeft: function( we ) {
        this.emit( we.sType, true );
    },
    _onHideLeft: function( we ) {
        var oSelf = this;
        this._bOpenLeft = false;
        this.hideBlocker(function(){
            //oSelf._welBlocker.css('opacity', 0);
            oSelf._releasePreventTouch();
            oSelf._welBlocker.shinsegae({ opacity: 0 });
        });
        this._welHtml.css(this._htEnableScrollCss);
        this._welHtml.css('position', '');
        this._welBody.css(this._htEnableScrollCss);
        this._removeStyle();
        this.emit( we.sType, true );
    },
    _onBeforeShowRight: function( we ) {
        this._welMainBody.css('height', '');
        this._welHtml.css(this._htDisableScrollCss);
        this._welHtml.css('position', 'fixed');
        this._welBody.css(this._htDisableScrollCss);
        this.emit( we.sType, true );
    },
    _onShowRight: function( we ) {
        var oSelf = this;
        this._bOpenRight = true;
        this._resizeBlocker(false);
        this.showBlocker(function(){
            //oSelf._welBlocker.stop().shinsegae({'opacity' : 0.8}, 200, 'easeInCubic');
            oSelf._freezePreventTouch();
        });

        this.emit( we.sType, false );
    },
    _onBeforeHideRight: function( we ) {
        this.emit( we.sType, we );
    },
    _onHideRight: function( we ) {
        var oSelf = this;
        this._bOpenRight = false;
        //this.hideBlocker();
        this.hideBlocker(function(){
            //oSelf._welBlocker.css('opacity', 0);
            oSelf._releasePreventTouch();
            oSelf._welBlocker.shinsegae({ opacity: 0 });
        });
        this._welHtml.css(this._htEnableScrollCss);
        this._welHtml.css('position', '');
        this._welBody.css(this._htEnableScrollCss);
        this._removeStyle();
        this.emit( we.sType, false );
    },
    _checkReSize: function( ) {
        var bResize = false, htClientSize = jindo.m._clientSize( );

        if( this._nScreenHeight !== htClientSize.height ) {
            this._nScreenHeight = htClientSize.height;
            bResize = true;
        }

        return bResize;
    },
    _resizeBlocker:function(bLeft){
        //var nClientSize = jindo.m._clientSize(),
        var nClientSize = jindo.$Document().clientSize(),
            sWidth = bLeft ? this._htSideLeft.nMargin + "px" : this._htSideRight.nMargin + "px",
            nPos = parseInt(nClientSize.width - this._htSideLeft.nMargin, 10);

        this._welBlocker.css({
            'width': sWidth,
            'left': bLeft ? nPos + "px" : "0px"
        });
    },
    showBlocker: function(fnCallBack){
        //offset을 이용한 방법도 존재
        //this._welBlocker.show();
        this._welBlocker.show(0, function(){
            if (fnCallBack && typeof (fnCallBack) === "function") {
                fnCallBack();
            }
        });
    },
    hideBlocker: function(fnCallBack){
        //this._welBlocker.hide();
        this._welBlocker.hide(0, function(){
            if (fnCallBack && typeof (fnCallBack) === "function") {
                fnCallBack();
            }
        });
    },
    _removeHeaderStyle: function(){
        this._welMainHeader.removeAttr('style');
    },
    _removeContainerStyle: function(){
        this._welMainContainer.css('transform', '');
        this._welMainContainer.css('WebkitTransform', '');
    },
    _removeStyle: function(){
        this._removeHeaderStyle();
        this._removeContainerStyle();
    },
    _resize : function(){
        if(this._bOpenLeft){
            this._resizeBlocker(true);
        }

        if(this._bOpenRight){
            this._resizeBlocker(false);
        }

        if(this._bOpenLeft || this._bOpenRight){
            this._welHtml.css(this._htDisableScrollCss);
            this._welBody.css(this._htDisableScrollCss);
        }
    },
    _freezePreventTouch: function(){
        this._welBlocker.length && this._welBlocker.on('touchmove.scrollable', function(e) {e.preventDefault();});
    },
    _releasePreventTouch: function(){
        this._welBlocker.length && this._welBlocker.off('touchmove.scrollable');
    },
    showLeftMenu: function( ) {
        this._oSideLeft.show( );
    },
    hideLeftMenu: function( ) {
        this.hideBlocker();
        this._oSideLeft.hide( );
    },
    toggleLeftMenu: function( ) {
        this._oSideLeft.toggle( );
    },
    showRightMenu: function( ) {
        this._oSideRight.show( );
    },
    hideRightMenu: function( ) {
        this.hideBlocker();
        this._oSideRight.hide( );
    },
    toggleRightMenu: function( ) {
        this._oSideRight.toggle( );
    }
}, ssg.Event.emitter );